import BaseClass from "./BaseClass";
import PaginationArrows from "./pagination/PaginationArrows";

const defaultOptions = {};

export default class Hotel extends BaseClass {

    constructor(options)
    {
        super(options, defaultOptions);

        this.init();
    }

    init()
    {

        if ($('[data-ride="carousel"]').length > 0) {
          // Style carousel indicators that are before active as active
            $('[data-ride="carousel"]').on('slid.bs.carousel', function () {
                $(this).find('[data-slide-to]').removeClass('before-active');
                let $activeSlide = $(this).find('[data-slide-to].active');
                let activeIndex = parseInt($activeSlide.data('slideTo')) + 1;
                $activeSlide.closest('[data-ride="carousel"]').find('.message.item.active [data-readmore]:not(.cropped)').readmore();

                for (let i = 0; i < activeIndex; i++) {
                    $(this).find('[data-slide-to="' + i + '"]').addClass('before-active');
                }
            })
        }

        $('[data-paginationarrows="most_popular"]').each((i, e) => {
            new PaginationArrows($(e));
        })
    }

  /**
   * Function that likes hotel if you are logged in
   *
   * @param {Element} e clicked element
   * @param {Integer} id hotel id
   */
    likeHotel(e, id)
    {
        let url = $(e).data('href');

        $.ajax({
            headers: {'X-App-Locale': $('[name="country"]').attr('content'),},
            type: 'POST',
            url: url,
            data: {
                hotelID: id,
                "_token": $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                let parsedData = JSON.parse(data);
                if (parsedData['unliked'] === true) {
                    $("[data-heart='liked_"+id+"']").css('display', 'none');
                    $("[data-heart='unliked_"+id+"']").css('display', 'block');
                } else if (parsedData['unliked'] === false) {
                    $("[data-heart='unliked_"+id+"']").css('display', 'none');
                    $("[data-heart='liked_"+id+"']").css('display', 'block');
                } else if (parsedData['profile'] === true) {
                    window.location.reload();
                }
            },
            error: function (err) {
            }
        })
    }
}
